import React, { useEffect } from 'react';

interface VisualizationControlsProps {
  columns: string[];
  selectedXAxis: string;
  selectedYAxis: string;
  chartType: 'line' | 'bar';
  onXAxisChange: (column: string) => void;
  onYAxisChange: (column: string) => void;
  onChartTypeChange: (type: 'line' | 'bar') => void;
}

  

const VisualizationControls: React.FC<VisualizationControlsProps> = ({
  columns,
  selectedXAxis,
  selectedYAxis,
  chartType,
  onXAxisChange,
  onYAxisChange,
  onChartTypeChange
}) => {
  
  return (
    <div className="visualization-controls">
      <div className="control-group">
        <label htmlFor="x-axis">X Axis:</label>
        <select
          id="x-axis"
          value={selectedXAxis}
          onChange={(e) => onXAxisChange(e.target.value)}
        >
          {columns.map(column => (
            <option key={column} value={column}>{column}</option>
          ))}
        </select>
      </div>

      <div className="control-group">
        <label htmlFor="y-axis">Y Axis:</label>
        <select
          id="y-axis"
          value={selectedYAxis}
          onChange={(e) => onYAxisChange(e.target.value)}
        >
          {columns.map(column => (
            <option key={column} value={column}>{column}</option>
          ))}
        </select>
      </div>

      <div className="control-group">
        <label htmlFor="chart-type">Chart Type:</label>
        <select
          id="chart-type"
          value={chartType}
          onChange={(e) => onChartTypeChange(e.target.value as 'line' | 'bar')}
        >
          <option value="line">Line Chart</option>
          <option value="bar">Bar Chart</option>
        </select>
      </div>
    </div>
  );
};

export default VisualizationControls; 